module.exports = __webpack_public_path__ + "static/media/car-race.280eea54.png";